// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + chunkId + "." + {"925":"28944fa4","2256":"f20e3241","7535":"f20e3241"}[chunkId] + ".css";
};